import LocationCategoryPage from "../containers/LocationCategory/LocationCategoryPage"
import RegionPage from "../containers/Region/RegionPage"

let ConfigSubRoutes = [
    {
        path: '/location-categories/*',
        container: LocationCategoryPage,
        exact: true,
    },
    {
        path: '/regions/*',
        container: RegionPage,
        exact: true,
    },
]
export default ConfigSubRoutes